import { VbzInputText } from "@smiles/voebiz-ui-kit";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { cpf } from "cpf-cnpj-validator";
import { Control, Controller } from "react-hook-form";

import { StateType } from "../../../hooks/types";

import {
  formatCpfOnString,
  handleKeyPressLetters,
  handleKeyPressNumber,
  regexPhoneFormatter,
} from "../../../utils/documentUtils";
import ControlledDropdown from "../../ControlledDropdown";

const AdminForm = ({ control, errors, state }: { control: Control; errors: any; state: StateType }) => {
  const { t } = useTranslation("register_admin");

  const validateCpfFormat = useCallback(() => cpf.isValid(state.member.DOcumentNumber), [state.member.DOcumentNumber]);
  function renderNumbersComponent(phone: string, placeholder: string) {
    return (
      <div className="inputTextContainer">
        <Controller
          name={phone}
          control={control}
          rules={{
            maxLength: 15,
            minLength: 14,
          }}
          render={({ name, value, onChange }) => (
            <VbzInputText
              name={name}
              placeholder={t(`input.text.${placeholder}.placeholder`)}
              onChange={(e) => {
                onChange(regexPhoneFormatter(e.target.value));
              }}
              value={value}
              maxLength={15}
              inputMode="tel"
              textLabel={t(`input.text.${placeholder}.label`)}
              onKeyDown={handleKeyPressNumber}
              errorMessage={t(`input.text.${placeholder}.errorMessage`)}
            />
          )}
        />
      </div>
    );
  }
  return (
    <div className="vbz-company-container-data-fields-right">
      <div className="inputTextContainer withError">
        <Controller
          name="DOcumentNumber"
          control={control}
          rules={{ required: true }}
          render={({ name, onChange, value }) => (
            <VbzInputText
              id={name}
              name={name}
              placeholder={t("input.text.cpf.placeholder")}
              maxLength={14}
              onKeyDown={handleKeyPressNumber}
              inputMode="numeric"
              textLabel={t("input.text.cpf.label")}
              onChange={onChange}
              value={formatCpfOnString(value)}
              validate={validateCpfFormat}
              errorMessage="O CPF informado não é válido. Por favor, tente de novo."
            />
          )}
        />
      </div>
      <div className="inputTextContainer withError">
        <Controller
          name="adminName"
          control={control}
          rules={{ required: true, pattern: /^[A-Za-zÀ-ÿ ]+$/i, minLength: 3 }}
          render={({ name, onChange, value }) => (
            <VbzInputText
              id={name}
              name={name}
              placeholder={t("input.text.admin_name.placeholder")}
              textLabel={t("input.text.admin_name.label")}
              minLength={3}
              onKeyDown={handleKeyPressLetters}
              onChange={onChange}
              value={value}
              errorMessage={t("input.text.admin_name.errorMessage")}
              forceError={Boolean(errors.adminName)}
            />
          )}
        />
      </div>
      <div className="inputTextContainer">
        <ControlledDropdown
          name="occupation"
          placeholder={t("input.text.occupation.placeholder")}
          errorMessage="Selecione a área de atuação vinculada ao seu cargo."
          actions={state.dropdowns.occupation.items.map((item) => ({ name: item.description }))}
          textLabel={t("input.text.occupation.label")}
          control={control}
          error={Boolean(errors.occupation)}
        />
      </div>
      <div className="inputTextContainer withError">
        <Controller
          name="email"
          control={control}
          rules={{ required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i }}
          render={({ name, onChange, value }) => (
            <VbzInputText
              id={name}
              name={name}
              placeholder={t("input.text.email.placeholder")}
              textLabel={t("input.text.email.label")}
              minLength={3}
              onChange={onChange}
              value={value}
              errorMessage="O e-mail informado não é válido. Por favor, tente de novo."
              forceError={Boolean(errors.email)}
            />
          )}
        />
      </div>
      {renderNumbersComponent("celPhoneNumber1", "phone_number_1")}
      {renderNumbersComponent("homePhoneNumber1", "phone_number_2")}
    </div>
  );
};

export default AdminForm;
